export { IncrementalSource } from './domain/record';
export var RecordType = {
    FullSnapshot: 2,
    IncrementalSnapshot: 3,
    Meta: 4,
    Focus: 6,
    ViewEnd: 7,
    VisualViewport: 8,
};
//# sourceMappingURL=types.js.map